export enum JourneyType {
  Game = 'game',
  Deal = 'deal',
}

export enum JourneyTrackingState {
  Started = 'Started',
  TrackingPending = 'TrackingPending',
  TrackingConfirmed = 'TrackingConfirmed',
  GoalPending = 'GoalPending',
  Credited = 'Credited',
  Expired = 'Expired',
  UnsupportedResume = 'UnsupportedResume',
  Archived = 'Archived',
}

export enum JourneyTimelineEventType {
  Started = 'Started',
  TrackingConfirmed = 'TrackingConfirmed',
  GoalCompleted = 'GoalCompleted',
  CreditPending = 'CreditPending',
  Credited = 'Credited',
  Expired = 'Expired',
  Archived = 'Archived',
}

export interface JourneyRewardDto {
  points: number;
  xp: number;
}

export interface JourneyGoalDto {
  id: number;
  name: string | null;
  position: number | null;
  points: number;
  xp: number;
  expiresOn: string | null;
  completedOn: string | null;
  paidOn: string | null;
  status: 'available' | 'tracking' | 'pending' | 'credited' | 'expired';
  gameGoalTypeId?: number | null;
  dealGoalTypeId?: number | null;
  partnerGoalId?: string | null;
}

export interface JourneyTimelineEventDto {
  id: string;
  type: JourneyTimelineEventType;
  occurredOn: string;
  title: string;
  description: string | null;
  reward: JourneyRewardDto | null;
}

export interface GameJourneyDetailsDto {
  type: JourneyType.Game;
  gameId: number;
  osTypeId: number | null;
  description: string | null;
  requirements: string[] | null;
  instructions: string[] | null;
}

export interface DealJourneyDetailsDto {
  type: JourneyType.Deal;
  dealId: number;
  osTypeId: number | null;
  description: string | null;
  requirements: string[] | null;
  instructions: string[] | null;
}

export type JourneyCategoryDetailsDto = GameJourneyDetailsDto | DealJourneyDetailsDto;

/**
 * A user-facing projection over authoritative game/deal sessions and goals.
 * Journey metadata is private to the owning user and never changes partner or
 * financial records.
 */
export interface JourneyDto {
  id: string;
  type: JourneyType;
  sessionId: number;
  sessionUid: string | null;
  title: string;
  partnerId: number;
  partnerName: string;
  imageUrl: string | null;
  startedOn: string;
  trackingState: JourneyTrackingState;
  trackingConfirmedOn: string | null;
  nextGoal: JourneyGoalDto | null;
  paidReward: JourneyRewardDto;
  pendingReward: JourneyRewardDto;
  expiresOn: string | null;
  canResume: boolean;
  resumeUnavailableReason: string | null;
  isPinned: boolean;
  privateTarget: string | null;
  reminderOn: string | null;
  archivedOn: string | null;
  canArchive: boolean;
  isHistory: boolean;
  goals: JourneyGoalDto[];
  timeline: JourneyTimelineEventDto[];
  details: JourneyCategoryDetailsDto;
}

export interface JourneyListResponseDto {
  journeys: JourneyDto[];
  pinnedJourneyId: string | null;
}

export interface SetJourneyTargetRequestDto {
  target: string | null;
}

export interface SetJourneyReminderRequestDto {
  reminderOn: string | null;
}
